export default {
  title: 'Personnaliser la commande',
  product_info: {
    earn_points: 'Gagnez {{points}} points',
  },
};
